module.exports = __webpack_public_path__ + "static/muthoot-fincorp-8c955a64b4b3d24eba711e89f0d8bafe.png";